import { SubjectLineMatchType } from "@redotech/redo-model/return-flow/condition";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { SubjectLineState } from "@redotech/redo-return-ui/flows/rules/conditions/subject-line";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Checkbox } from "@redotech/redo-web/checkbox";
import { Flex } from "@redotech/redo-web/flex";
import { LabeledInput } from "@redotech/redo-web/labeled-input";
import { memo, useState } from "react";

export const SubjectLineDetails = memo(function SubjectLineDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<SubjectLineState>) {
  const [inputValue, setInputValue] = useState("");

  const matchModeOptions = [
    {
      id: SubjectLineMatchType.EXACT,
      type: "text" as const,
      text: "entire subject line is exactly",
      value: SubjectLineMatchType.EXACT,
    },
    {
      id: SubjectLineMatchType.CONTAINS,
      type: "text" as const,
      text: "contains",
      value: SubjectLineMatchType.CONTAINS,
    },
  ];

  const selectedMatchMode = matchModeOptions.find(
    (option) => option.id === state.matchMode,
  );

  return (
    <>
      <RedoSingleSelectDropdownInput
        disabled={disabled}
        label="Match mode"
        options={matchModeOptions}
        optionSelected={({ item }) => {
          setState({ ...state, matchMode: item.id as typeof state.matchMode });
        }}
        selectedItem={selectedMatchMode}
      />
      <RedoTagInputField
        delimiters={["newline"]}
        inputValue={inputValue}
        label="Subject text to match"
        placeholder="Enter subject text to match"
        setInputValue={setInputValue}
        setTags={(queryStrings) => {
          const uniqueStrings = Array.from(new Set(queryStrings));
          setState({ ...state, queryStrings: uniqueStrings });
        }}
        state={disabled ? "disabled" : "default"}
        tags={(state.queryStrings || []).map((text) => ({ text }))}
      />

      <Flex>
        <LabeledInput label="Case sensitive">
          <Checkbox
            onChange={(v) => setState({ ...state, caseSensitive: v })}
            value={state.caseSensitive}
          />
        </LabeledInput>{" "}
      </Flex>
    </>
  );
});
